import React, { Component } from "react";
import { isMobile } from "react-device-detect";
import { TextField, Button, CircleProgress } from "reactackle";
import _ from "lodash";

class AgraniRegCard extends Component {
  state = {
    data: {
      path: "",
      payload: ""
    },
    mode: "collapseView", //1. collapseView 2. expandView 3. expandEdit
    updating: false
  };
  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload) => {
    // console.log(
    //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
    // );
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(prevState => {
        if (prevState && prevState.data.payload !== null) {
          return {
            ...prevState,
            data: {
              ...prevState.data,
              payload: {
                ...prevState.data.payload,
                ...tmpState
              }
            }
          };
        } else {
          return {
            ...prevState,
            data: {
              path: prevState.data.path,
              payload: {
                ...tmpState
              }
            }
          };
        }
      });
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          ...tmpState
        };
      });
    }
  };

  getExpandViewCard = () => {
    let req = this.props.req;
    return (
      <div>
        <table className="table table-bordered" style={{ marginBottom: "0px" }}>
          <tbody>
            <tr>
              <td>NAME</td>
              <td>{req.senderName}</td>
            </tr>
            <tr>
              <td>ADDRESS</td>
              <td>{req.senderAddress}</td>
            </tr>
            <tr>
              <td>MOBILE</td>
              <td>{req.mobile}</td>
            </tr>
            <tr>
              <td>ID TYPE</td>
              <td>{req.idType}</td>
            </tr>
            <tr>
              <td>ID NUMBER</td>
              <td>{req.idNumber}</td>
            </tr>
            <tr>
              <td>REMIT ID</td>
              <td>{req.exchId}</td>
            </tr>
            <tr>
              <td>STATUS</td>
              <td>{this.getStatusButtons()}</td>
            </tr>
            <tr>
              <td>COMMENTS</td>
              <td>{req.comments}</td>
            </tr>
            <tr>
              <td>INTERNAL NOTES</td>
              <td>{req.internalNotes}</td>
            </tr>

            <tr>
              <td>APPLCTN DATE</td>
              <td>{req.appDate}</td>
            </tr>
            <tr>
              <td>EXCHANGE</td>
              <td>{req.exchange}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  getCollapsViewCard = () => {
    let req = this.props.req;
    return (
      <div>
        <table className="table table-bordered" style={{ marginBottom: "0px" }}>
          <tbody>
            <tr>
              <td>NAME</td>
              <td>{req.senderName}</td>
            </tr>
            <tr>
              <td>ADDRESS</td>
              <td>{req.senderAddress}</td>
            </tr>
            <tr>
              <td>MOBILE</td>
              <td>{req.mobile}</td>
            </tr>
            <tr>
              <td>STATUS</td>
              <td>{this.getStatusButtons()}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  saveHandler = bucket => {
    let cloudPath = this.props.selectedExchange + "Regs/" + bucket.key;
    this.stateChangeHandler(true, "updating", false);
    this.props.firebase.db
      .ref("/" + cloudPath)
      .once("value")
      .then(snap => {
        return snap.ref.set({
          ...bucket
        });
      })
      .catch(err => {
        console.log(err);
        this.stateChangeHandler(false, "updating", false);
        return console.log("some error: " + err);
      })
      .then(err => {
        //clear the bucket
        this.props.firebase.db
          .ref("/remSvc" + "/" + bucket.mobile + "/remRegs/" + bucket.key)
          .once("value")
          .then(snap => {
            //console.log("ta da");
            // this.props.onNotifyUsers(
            //   "You passport application is now under the status : " + newStatus,
            //   [bucket.cellPhone]
            // );
            this.stateChangeHandler(false, "updating", false);
            return snap.ref.set({
              ...bucket
            });
          })
          .catch(err => {
            console.log(err);
            this.stateChangeHandler(false, "updating", false);
            return console.log("some error: " + err);
          })
          .then(err => {
            this.stateChangeHandler(false, "updating", false);
          });
      });
  };

  getStatusButtons = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignContent: "center",
          justifyContent: "space-evenly"
        }}
      >
        <div
          style={{
            padding: "3px",
            textAlign: "center",
            border: "1px solid gainsboro",
            borderRadius: isMobile ? "5px" : "0px",
            backgroundColor:
              this.props.req.status === "PENDING"
                ? "rgb(30, 101, 144)"
                : "white",
            margin: "3px",
            padding: "6px",
            fontWeight: "bold",
            color: this.props.req.status === "PENDING" ? "white" : "black",
            fontSize: "12px",
            minWidth: "80px"
          }}
          onClick={() => {
            let currVals = _.cloneDeep(this.props.req);
            if (currVals.status !== "PENDING") {
              currVals.status = "PENDING";
              confirm("Do you want to change the status to PENDING?") &&
                this.saveHandler(currVals);
            }
          }}
        >
          <div>PENDING</div>
        </div>

        <div
          style={{
            padding: "3px",
            textAlign: "center",
            border: "1px solid gainsboro",
            borderRadius: isMobile ? "5px" : "0px",
            backgroundColor:
              this.props.req.status === "ACTIVE"
                ? "rgb(30, 101, 144)"
                : "white",
            margin: "3px",
            padding: "6px",
            fontWeight: "bold",
            color: this.props.req.status === "ACTIVE" ? "white" : "black",
            fontSize: "12px",
            minWidth: "80px"
          }}
          onClick={() => {
            let currVals = _.cloneDeep(this.props.req);
            if (currVals.status !== "ACTIVE") {
              currVals.status = "ACTIVE";
              confirm("Do you want to change the status to ACTIVE?") &&
                this.saveHandler(currVals);
            }
          }}
        >
          <div>ACTIVE</div>
        </div>
      </div>
    );
  };

  getStatementLoader = () => {
    return (
      <div
        style={{
          textAlign: "center",
          paddingTop: "10px"
        }}
      >
        <CircleProgress
          indeterminate
          subtitle="Submitting application... please be patient as it can take upto a minute (একটু অপেক্ষা করুন, ফরম ইমেইল হতে এক মিনিটের মতো লাগতে পারে।)"
          circleSize={40}
          strokeSize={5}
          labelPositionY="bottom"
          labelPositionX="center"
        />
      </div>
    );
  };

  getRegFormField = (fieldId, placeholder, caption, multiline) => {
    return (
      <div>
        <div
          style={{
            padding: "1px",
            textAlign: "right",
            border: "1px solid gainsboro",
            borderRadius: isMobile ? "5px" : "0px",
            backgroundColor: "white",
            zIndex: "-9",
            margin: "5px",
            fontSize: "12px"
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row"
            }}
          >
            <div
              style={{
                width: "30%",
                lineHeight: "12px",
                textAlign: "left",
                paddingLeft: "5px",
                margin: "auto"
              }}
            >
              {caption}
            </div>
            <div
              style={{
                width: "70%",
                border: "1px solid gainsboro",
                borderRadius: "5px",
                borderTopLeftRadius: "0px",
                borderBottomLeftRadius: "0px",
                margin: "2px"
              }}
            >
              <TextField
                value={this.state.data.payload[fieldId]}
                onChange={e => {
                  this.stateChangeHandler(e.value, fieldId, true);
                }}
                multiline={multiline}
                fullWidth
                placeholder={placeholder}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  getRegFormTwinButtons = (fieldId, caption, btn1Text, btn2Text) => {
    return (
      <div>
        <div
          style={{
            padding: "1px",
            textAlign: "right",
            border: "1px solid gainsboro",
            borderRadius: isMobile ? "5px" : "0px",
            backgroundColor: "white",
            zIndex: "-9",
            margin: "5px",
            fontSize: "12px"
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row"
            }}
          >
            <div
              style={{
                width: "30%",
                lineHeight: "12px",
                textAlign: "left",
                paddingLeft: "5px",
                margin: "auto"
              }}
            >
              {caption}
            </div>
            <div
              style={{
                width: "70%",
                display: "flex",
                flexDirection: "row"
              }}
            >
              <Button
                text={btn1Text}
                colorScheme={
                  this.state.data.payload[fieldId] === btn1Text
                    ? "primary"
                    : "white"
                }
                onPress={() => {
                  this.stateChangeHandler(btn1Text, fieldId, true);
                }}
              />
              <Button
                text={btn2Text}
                colorScheme={
                  this.state.data.payload[fieldId] === btn2Text
                    ? "primary"
                    : "white"
                }
                onPress={() => {
                  this.stateChangeHandler(btn2Text, fieldId, true);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  getExpandEditCard = () => {
    return (
      <div>
        <div>{this.getRegFormField("senderName", "", "FULL NAME", false)}</div>
        <div>{this.getRegFormField("senderAddress", "", "ADDRESS", true)}</div>
        <div>{this.getRegFormField("mobile", "", "MOBILE", true)}</div>
        <div>
          {this.getRegFormTwinButtons("status", "STATUS", "PENDING", "ACTIVE")}
        </div>
        <div>
          {this.getRegFormTwinButtons(
            "idType",
            "ID TYPE",
            "PASSPORT",
            "LICENSE"
          )}
        </div>
        <div>{this.getRegFormField("idNumber", "", "ID #", false)}</div>
        <div>{this.getRegFormField("exchId", "", "REMIT ID", false)}</div>
        <div>{this.getRegFormField("appDate", "", "APLCTN DATE", true)}</div>
        <div>{this.getRegFormField("comments", "", "COMMENTS", true)}</div>
        <div>
          {this.getRegFormField("internalNotes", "", "INTERNAL NOTES", true)}
        </div>
        <div>
          {this.getRegFormTwinButtons("idVerified", "ID VERFD", "YES", "NO")}
        </div>
        <div>
          {this.getRegFormTwinButtons(
            "inPersonVerified",
            "ID PERSON VERFD",
            "YES",
            "NO"
          )}
        </div>
      </div>
    );
  };

  getViewBottomBar = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          paddingLeft: "10px",
          paddingRight: "10px"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            padding: "3px",
            lineHeight: "18px"
          }}
          onClick={() => {
            let currVals = _.cloneDeep(this.props.req);
            this.stateChangeHandler(
              { path: "", payload: currVals },
              "data",
              false
            );
            this.stateChangeHandler("expandEdit", "mode", false);
          }}
        >
          <i
            className={"fa fa-pencil"}
            style={{ fontSize: "18px", marginRight: "5px" }}
          />{" "}
          EDIT
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            padding: "3px",
            lineHeight: "18px"
          }}
          onClick={() => {
            if (this.state.mode === "collapseView") {
              this.stateChangeHandler("expandView", "mode", false);
            } else {
              this.stateChangeHandler("collapseView", "mode", false);
            }
          }}
        >
          {this.state.mode === "collapseView" ? "MORE" : "LESS"}{" "}
          <i
            className={
              this.state.mode === "collapseView"
                ? "fa fa-chevron-circle-down"
                : "fa fa-chevron-circle-up"
            }
            style={{ fontSize: "18px", marginLeft: "5px" }}
          />
        </div>
      </div>
    );
  };

  manualUpdates = () => {
    this.saveHandler(this.state.data.payload);
    this.stateChangeHandler("expandView", "mode", false);
  };

  getEditBottomBar = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          paddingLeft: "5px",
          paddingRight: "5px"
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            padding: "3px",
            lineHeight: "18px"
          }}
          onClick={() => {
            this.stateChangeHandler("collapseView", "mode", false);
          }}
        >
          <i
            className={"fa fa-close"}
            style={{ fontSize: "18px", marginRight: "5px" }}
          />{" "}
          CANCEL
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            padding: "3px",
            lineHeight: "18px"
          }}
          onClick={() => {
            confirm("Do you want to save changes?") && this.manualUpdates();
          }}
        >
          SAVE
          <i
            className={"fa fa-save"}
            style={{ fontSize: "18px", marginLeft: "5px" }}
          />
        </div>
      </div>
    );
  };

  render() {
    return (
      <div
        style={{
          border: "1px solid gainsboro",
          borderRadius: "5px",
          padding: "2px",
          marginBottom: "10px"
        }}
      >
        {this.state.mode === "expandEdit" && this.getEditBottomBar()}
        {this.state.mode !== "expandEdit" && this.getViewBottomBar()}
        <div
          style={{
            backgroundColor: "gainsboro",
            lineHeight: "1px",
            minHeight: "1px",
            marginLeft: "-2px",
            marginRight: "-2px",
            marginBottom: "2px"
          }}
        ></div>
        {this.state.updating && this.getStatementLoader()}
        {/* <div
          style={{
            margin: "10px"
          }}
        >
          {this.state.mode !== "expandEdit" && this.getStatusButtons()}
        </div> */}
        {this.state.mode === "expandView" && this.getExpandViewCard()}
        {this.state.mode === "collapseView" && this.getCollapsViewCard()}
        {this.state.mode === "expandEdit" && this.getExpandEditCard()}
      </div>
    );
  }
}

export default AgraniRegCard;



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/AgraniRegCard.jsx